export default{sources:{avif:"__VITE_ASSET__C7r7Vf0H__ 400w",webp:"__VITE_ASSET__C6eIB3pZ__ 400w"},img:{src:"__VITE_ASSET__CZT1FX4___",w:400,h:866}};